/* eslint react/no-danger: [0] */
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const withStyles = require('withStyles').default
const getLayoutColor = require('module/user/helpers/get_layout_color')
const _ = require('lib/underscore')
const styles = require('./profile_view.less')
const getLuminance = require('lib/get_luminance')
const SmallProfileView = require('./templates/small')
const MediumProfileView = require('./templates/medium')
const LargeProfileView = require('./templates/large')
const Raven = require('lib/raven')
const hasFeature = require('module/user/helpers/has_feature')
const funnels = require('lib/funnels')
const log = require('log').create('react', 'profile') // eslint-disable-line

class ProfileView extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            profile_id: _.uniqueId('profile'),
        }
    }

    getChildContext() {
        return {
            profile_id: this.state.profile_id,
        }
    }

    getRenderProps() {
        const {
            user,
            color,
            ledge,
            mapped,
            nested,
            preview,
            nav,
        } = this.props

        let { template_id } = this.props
        const { profile_id } = this.state

        // accept template_id as prop
        // use user properties as default if prop is not provided
        template_id = template_id || user.layout.template_id

        // get preview color or user's color
        const layout_color = color || getLayoutColor(user)
        const luminance = getLuminance(layout_color)

        // determine if we should render footer logo
        const is_less_branding = funnels.get('20230206_less_branding').is('experiment')
        const render_footer_logo = is_less_branding && ! hasFeature(user, 'upgrade')

        // define className
        const className = classNames([
            'profile',
            template_id,
            styles.scope,
            // only output uniqueId for nested profiles
            nested ? profile_id : false,
        ], {
            nested,
            preview,
            mapped,
            'has-nav': nav,
            'has-ledge': ledge,
            'has-footer-logo': render_footer_logo,
        })

        // get Template component
        const Template = this.getTemplate(template_id)

        return {
            color: layout_color,
            Template,
            className,
            user,
            luminance,
            nested,
        }
    }

    getTemplate(template_id) {
         
        const {
            SmallProfileView,
            MediumProfileView,
            LargeProfileView,
        } = this.components()
         

        const { user } = this.props

        switch (template_id) {
            case 'small':
                return SmallProfileView
            case 'medium':
                return MediumProfileView
            case 'large':
                return LargeProfileView
            default:
                Raven.captureMessage('Invalid template_id', {
                    extra: {
                        template_id,
                        user,
                    },
                })
                return SmallProfileView
        }
    }

    components() {
        return {
            SmallProfileView,
            MediumProfileView,
            LargeProfileView,
        }
    }

    render() {
        const {
            Template,
            className,
            user,
            color,
            luminance,
            nested,
        } = this.getRenderProps()

        return (
            <Template
                className={className}
                user={user}
                luminance={luminance}
                color={color}
                nested={nested}
                />
        )
    }

}

ProfileView.propTypes = {
    user: PropTypes.shape({
        user_name: PropTypes.string.isRequired,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        bio: PropTypes.string,
        images: PropTypes.arrayOf(PropTypes.object),
        interests: PropTypes.arrayOf(PropTypes.object),
        locations: PropTypes.arrayOf(PropTypes.object),
        roles: PropTypes.arrayOf(PropTypes.object),
        layout: PropTypes.shape({
            template_id: PropTypes.string,
            color_theme_id: PropTypes.string,
            color: PropTypes.string,
        }),
    }).isRequired,
    template_id: PropTypes.string,
    color: PropTypes.string,
    ledge: PropTypes.bool,
    mapped: PropTypes.bool,
    nested: PropTypes.bool,
    preview: PropTypes.bool,
    nav: PropTypes.bool,
}

ProfileView.defaultProps = {
    nav: false,
    ledge: false,
    mapped: false,
    nested: false,
    preview: false,
}
ProfileView.childContextTypes = {
    profile_id: PropTypes.string,
}

module.exports = withStyles(styles)(ProfileView)
module.exports.UnstyledProfileView = ProfileView
